// Web shim for react-native-chart-kit — basic bar chart using HTML/CSS
import React from 'react';
import { View, Text } from 'react-native';

export function BarChart({
  data,
  width = 300,
  height = 220,
  chartConfig = {},
  style,
  fromZero,
  showValuesOnTopOfBars,
}) {
  const labels = data?.labels || [];
  const datasets = data?.datasets || [];
  const values = datasets[0]?.data || [];
  const maxVal = Math.max(...values, 1);
  const barColor = chartConfig?.color ? chartConfig.color(1) : '#1B5E20';
  const labelColor = chartConfig?.labelColor ? chartConfig.labelColor(1) : '#333';
  const barWidth = Math.max(20, (width - 60) / labels.length - 8);
  const chartHeight = height - 50;

  return (
    <View style={[{ width, height }, style]}>
      <View style={{ flex: 1, flexDirection: 'row', alignItems: 'flex-end', paddingLeft: 30, paddingBottom: 20 }}>
        {values.map((val, i) => {
          const barH = Math.max(2, (val / maxVal) * chartHeight);
          return (
            <View key={i} style={{ alignItems: 'center', marginHorizontal: 4, flex: 1 }}>
              {showValuesOnTopOfBars && (
                <Text style={{ fontSize: 10, color: labelColor, marginBottom: 2 }}>{val}</Text>
              )}
              <View
                style={{
                  width: barWidth,
                  height: barH,
                  backgroundColor: barColor,
                  borderTopLeftRadius: 4,
                  borderTopRightRadius: 4,
                }}
              />
              <Text
                style={{ fontSize: 10, color: labelColor, marginTop: 4, textAlign: 'center' }}
                numberOfLines={1}
              >
                {labels[i] || ''}
              </Text>
            </View>
          );
        })}
      </View>
    </View>
  );
}

export function LineChart(props) {
  return <BarChart {...props} />;
}

export function PieChart() {
  return null;
}
